import { render } from "./EditParentPage.vue?vue&type=template&id=7dda7e9a&ts=true"
import script from "./EditParentPage.vue?vue&type=script&lang=ts"
export * from "./EditParentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__